import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.st = new SmartTable();
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/directory-manage-domains.controller.js